import { ChangeDetectionStrategy, Component, input } from '@angular/core';

export type NoteTone = 'info' | 'warn' | 'danger';

@Component({
  selector: 'ui-note-bar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './ui-note-bar.component.html',
})
export class UiNoteBarComponent {
  readonly tone = input<NoteTone>('info');

  toneClass(): string {
    switch (this.tone()) {
      case 'warn':
        return 'border-amber-200 bg-amber-50 text-amber-800';
      case 'danger':
        return 'border-red-200 bg-red-50 text-red-700';
      default:
        return 'border-indigo-100 bg-indigo-50 text-indigo-700';
    }
  }
}
